export const DEFAULT_PROD_URL = "https://vgf-static.beefee.co.uk/";
export const DEV_URL = "https://gs-client-newjenkins.testowaplatforma123.net/"

export const DEFAULT_PROD_URL_REDIRECTS = "https://vgf-static.beefee.co.uk/redirects/";
export const DEV_URL_REDIRECTS = "https://gs-client-newjenkins.testowaplatforma123.net/redirects/"

export const RETRY_BASE_TIME = 1_000;
export const RETRY_BASE_ATTEMPTS = 3;
